import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import AddSvg from 'assets/svgr-icons/Add.svg'

export const AddAvatarCard = styled.button`
  flex: 1;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  border-radius: ${RADII.card};
  background-color: ${COLORS.fillSubtle};
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    border-color: ${COLORS.primaryDark};
    background-color: ${COLORS.surface};
  }
`

export const AddIcon = styled(AddSvg)`
  width: 24px;
  height: 24px;
  color: ${COLORS.secondaryDark};
`
